"use strict";

var Order = require('./Order');

var SampleSetsOrder = require('./SampleSetsOrder');

var TestPrintsOrder = require('./TestPrintsOrder');

function getMatchingConstructor(order_type) {
  switch (order_type) {
    case 'sample sets':
      return SampleSetsOrder;

    case 'test prints':
      return TestPrintsOrder;

    default:
      return Order;
  }
}

module.exports = getMatchingConstructor;